import { RouteType } from "types/RouteType";
import { databaseDate } from "@intrasync/utils";
import CastingMapStore from "./CastingMapStore";
import { ServiceStore, RootStore } from "@intrasync/stores";
// import CastingMapIcon from '@mui/icons-material/AutoStories';
// import { toJS } from 'mobx';

// interface PanelResponse {
//   data: Panel[];
// }

// interface Panel {
//   controlUUID: string;
// }

const castingMapRoute: RouteType[] = [
  {
    name: "Production Floor Map",
    path: "/plant-map",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Production Floor Map",
        component: () => import("./CastingMap.Header"), // Assuming a Header component exists or will be created
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        component: () => import("./CastingMap.Body"), // Assuming a Body component exists or will be created
        grayBackground: true, // Add if needed
      },
    },
    group: "Production",
    requiresAuth: true, // Assuming it requires authentication since it requires permission
    requiresPermission: false,

    hidden: true,
    defaultQueryParams: { castingDate: databaseDate() },
    channels: [
      "casting-map-layout",
      "job",
      "job",
      "panel-revit",
      "panel-plant",
      "panel-yard",
      "hold",
    ],
    enableAutoFind: false,
    beforeEnter: ({ rootStore }) => {
      const castingMapLayoutStore =
        rootStore.castingMapLayoutStore as ServiceStore | undefined;
      if (castingMapLayoutStore) {
        castingMapLayoutStore.find();
      }

      return true;
    },
    onEnter: async ({ rootStore, queryParams }) => {
      const castingMapStore = rootStore.castingMapStore as CastingMapStore;
      const { checkForStaleCastingDates } = castingMapStore;

      const jobStore = rootStore.jobStore as ServiceStore;

      const panelStore = rootStore.panelStore as ServiceStore;

      // const panelStore = rootStore.panelStore as ServiceStore;

      const holdStore = rootStore.holdStore as ServiceStore;

      const castingDate = queryParams?.castingDate as string;
      // console.log('ONENTER castingDate', castingDate);
      holdStore.find();
      jobStore.find();
      if (castingDate) {
        // const dayBeforeCasting = getLastWorkday(castingDate);

        panelStore.find({
          query: { castingDate: databaseDate(castingDate) },
        });
      }

      checkForStaleCastingDates();
    },
    onParamsChange: async ({ rootStore }) => {
      // console.log('ONPARAMSCHANGE queryParams', queryParams);

      rootStore.routerStore?.triggerEnterSideEffects();
      //   const {
      //     castingMapStore: { setCastingDisplayDate },
      //     castingMapLayoutStore: { find: findCastingMapLayouts },
      //     jobStore: { find: findJobs },
      //     jobStore: { find: findJobPlant },
      //     panelStore: { find: findRevitPanels },
      //     panelStore: { find: findPlantPanels },
      //     holdStore: { find: findPanelHolds },
      //   } = rootStore;
      //   const castingDate = toJS(queryParams.castingDate);
      //   findJobPlant();

      //   findCastingMapLayouts();
      //   setCastingDisplayDate(castingDate);
      //   const dayBeforeCasting = getLastWorkday(castingDate);
      //   findPlantPanels({
      //     query: {
      //       $or: [
      //         { castingDate: databaseDate(castingDate) },
      //         { castingDate: dayBeforeCasting },
      //       ],
      //     },
      //   }).then((foundPlantPanels: PanelResponse) => {
      //     const controlUUIDs = foundPlantPanels?.data?.map(
      //       (panel) => panel.controlUUID
      //     );
      //     if (controlUUIDs) {
      //       findRevitPanels({
      //         query: { controlUUID: { $in: [...controlUUIDs] } },
      //       });
      //     }
      //   });

      //   findPanelHolds();
      //   findJobs();
      //   rootStore.castingMapStore.checkForStaleCastingDates();
    },

    // dialogs: [
    //   {
    //     name: 'Panel Details',
    //     component: () => import('./CastingMap.Dialogs.PanelDetails'), // Assuming a PanelDetails component exists or will be created
    //     width: 'lg',
    //     height: 'lg',
    //   },
    //   {
    //     name: 'Panel Hold Details',
    //     component: () => import('./CastingMap.Dialogs.PanelHoldDetails'), // Assuming a PanelHoldDetails component exists or will be created
    //     width: 'lg',
    //     height: 'lg',
    //   },
    //   {
    //     name: 'Job Details',
    //     component: () => import('./CastingMap.Dialogs.JobDetails'), // Assuming a JobDetails component exists or will be created
    //     width: 'lg',
    //     height: 'lg',
    //   },
    // ],
    dialogs: [
      {
        name: "Job Stats",
        title: "Job Stats",
        component: () =>
          import("./CastingMapDialogs/CastingMapDialog.JobStatDetails"),
        onSubmit: (onSubmitProps) => {
          console.log("AddClientDialog onSubmitProps", onSubmitProps);
          // rootStore.projectStore.create({
          //   projectId: 'BIS-4',
          //   projectName: 'projectName',
          //   projectDescription: 'projectDescription',
          //   projectStatus: 'Active',
          // });
        },
        cancelButton: true,
      },
      {
        name: "Panel Details",
        title: "Panel Details",
        component: () =>
          import("./CastingMapDialogs/CastingMapDialog.PanelDetails"),
        onSubmit: (props) => {
          const rootStore = props?.rootStore as RootStore;
          // console.log('AddClientDialog onSubmitProps');

          const castingMapStore = rootStore.castingMapStore as CastingMapStore;

          castingMapStore.submitCastingMapDialog();
        },
        onSubmitValidation: (props) => {
          const castingMapStore = props?.rootStore
            .castingMapStore as CastingMapStore;
          // console.log('AddClientDialog onSubmitValidation');

          return Object.keys(castingMapStore.panelEdits).length === 0;
        },
        cancelButton: true,
      },
      {
        name: "Panel QA Details",
        title: "Panel QA Details",
        component: () =>
          import("./CastingMapDialogs/CastingMapDialog.PanelQADetails"),
        onSubmit: (props) => {
          const rootStore = props?.rootStore as RootStore;
          // console.log('AddClientDialog onSubmitProps');

          const castingMapStore = rootStore.castingMapStore as CastingMapStore;

          castingMapStore.submitCastingMapDialog();
        },
        onSubmitValidation: (props) => {
          const castingMapStore = props?.rootStore
            .castingMapStore as CastingMapStore;
          // console.log('AddClientDialog onSubmitValidation');
          return Object.keys(castingMapStore.panelEdits).length === 0;
        },
      },
      {
        name: "Assign Station",
        title: "Assign Station",
        component: () =>
          import("./CastingMapDialogs/CastingMapDialog.AssignTables"),
        onSubmit: () => {
          // const castingMapStore = props?.rootStore
          //   .castingMapStore as CastingMapStore;
          // console.log('AddClientDialog onSubmitProps');

          // const castingMapStore = props.rootStore.castingMapStore as CastingMapStore;

          // castingMapStore.submitCastingMapDialog();
          return true;
        },
        submitButtonText: "Done",

        cancelButton: true,
      },
      {
        name: "QR Scanner",
        title: "QR Scanner",
        component: () =>
          import("./CastingMapDialogs/CastingMapDialog.QRScanner"),
        onSubmit: () => {
          // const castingMapStore = props?.rootStore
          //   .castingMapStore as CastingMapStore;
          // console.log('AddClientDialog onSubmitProps');

          // const castingMapStore = props.rootStore.castingMapStore as CastingMapStore;

          // castingMapStore.submitCastingMapDialog();
          return true;
        },
        submitButtonText: "Done",

        cancelButton: true,
      },
    ],
  },
];

export default castingMapRoute;
